import React, { useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./SkillPopover.css";

const SKILL_DESCRIPTIONS = {
  ".NET Development": "Experience in building full-stack applications using the .NET framework, including ASP.NET Core for web development and Entity Framework for database management.",
  "Flutter/Dart": "Proficient in creating cross-platform mobile applications using Flutter and Dart", 
  "HTML/CSS": "Skilled in crafting responsive and visually appealing web interfaces using HTML5 and CSS3, with a focus on modern design principles.",
  "Python": "Experienced in building automation scripts, analyzing ai data and creating efficient Rest APIs using FastAPI",
  "JavaScript": "Skilled in supporting websites with interactive features and dynamic content using JavaScript, including experience with modern frameworks like React.",
  "React": "Proficient in building dynamic and responsive user interfaces using React, with experience in component-based architecture.",
  "C++": "Experience in developing performance critical libraries used to analyze data in various flutter projects",
  "Database Management": "Skilled in designing and managing relational and non-relational databases using MySQL, including writing complex queries and optimizing database performance.",
  "Azure DevOps": "Experience in using Azure DevOps for continuous integration and deployment, version control, and project management.",
  "Jira Service Management": "Proficient in using Jira Service Management for issue tracking, project management, and team collaboration.",
  "SonarQube": "Experience in using SonarQube for code quality analysis, identifying bugs, vulnerabilities, and code smells in various programming languages.",
  "Version Control": "Skilled in using Git for version control",
};

export default function SkillPopover({ skill, onClose }) {
  const ref = useRef(null);

  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose();
    }
    function onClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    }
    document.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onClickOutside);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("mousedown", onClickOutside);
    };
  }, [onClose]);

  if (!skill) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="skill-popover-backdrop"
        role="dialog"
        aria-modal="true"
        aria-label={`${skill} info`}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2 }}
      >
        <motion.div
          className="skill-popover"
          ref={ref}
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.8, opacity: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 300 }}
        >
          <button className="skill-popover-close" onClick={onClose} aria-label="Close">×</button>
          <div className="skill-popover-header">
            <div className="skill-popover-avatar">{skill.slice(0, 2).toUpperCase()}</div>
            <h3 className="skill-popover-title">{skill}</h3>
          </div>
          <div className="skill-popover-body">
            <p>{SKILL_DESCRIPTIONS[skill] || "Short description coming soon."}</p>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
